<template>
  <v-layout class="primary_dark" mx-0 row>
    <v-flex
      style="background-position-x: center; background-size: cover;"
      :style="{ backgroundImage: 'url(' + `imagenes/credito_carro2.jpg` + ')' }"
      xs12
      sm12
      md6
    ></v-flex>
    <v-flex xs12 sm12 md6>
      <v-layout align-center justify-center mx-0 row wrap>
        <v-flex xs10 sm10 md8 class="py-12">
          <vc-simulator-credit-car :selector="true"></vc-simulator-credit-car>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>
<style scoped>
.bg-accent-dark {
  background-color: #f9a61b !important;
}
</style>
<script>
export default {
  props: ["image", "imgleft"],
  data: () => ({
    publicPath: process.env.BASE_URL,
  }),
};
</script>
